import api, { type ApiResponse } from './axiosInstance';
import type { Uom } from '../features/epc/manager/types';

export type ScopeChangeRequestStatus = 'pending' | 'accepted' | 'rejected';

export interface ScopeChangeRequest {
  id: string;
  epcProjectId: string;
  orgUnitId?: string;
  taskKey: string;
  taskName: string;
  proposedScopeQty: number;
  proposedUom: Uom;
  reason: string;
  currentScope: { scopeQty: number; uom: string } | null;
  status: ScopeChangeRequestStatus;
  requestedByUserId: string;
  requestedByName: string;
  decidedByUserId?: string;
  decidedAt?: string;
  decisionNote?: string;
  createdAt: string;
}

export async function createScopeChangeRequest(
  projectId: string,
  taskKey: string,
  body: {
    orgUnitId?: string;
    taskName: string;
    proposedScopeQty: number;
    proposedUom: Uom;
    reason: string;
  },
): Promise<ScopeChangeRequest> {
  const r = await api.post<ApiResponse<ScopeChangeRequest>>(
    `/epc/projects/${projectId}/schedule/tasks/${encodeURIComponent(taskKey)}/scope-change-requests`,
    body,
  );
  return r.data.data;
}

export async function listTaskScopeChangeRequests(projectId: string, taskKey: string): Promise<ScopeChangeRequest[]> {
  const r = await api.get<ApiResponse<ScopeChangeRequest[]>>(
    `/epc/projects/${projectId}/schedule/tasks/${encodeURIComponent(taskKey)}/scope-change-requests`,
  );
  return r.data.data;
}

export async function listProjectScopeChangeRequests(
  projectId: string,
  status?: ScopeChangeRequestStatus,
): Promise<ScopeChangeRequest[]> {
  const r = await api.get<ApiResponse<ScopeChangeRequest[]>>(`/epc/projects/${projectId}/scope-change-requests`, {
    params: { status },
  });
  return r.data.data;
}

export async function listAllScopeChangeRequests(status?: ScopeChangeRequestStatus): Promise<ScopeChangeRequest[]> {
  const r = await api.get<ApiResponse<ScopeChangeRequest[]>>('/epc/scope-change-requests', { params: { status } });
  return r.data.data;
}

export async function decideScopeChangeRequest(
  id: string,
  body: { decision: 'accept' | 'reject'; decisionNote?: string },
): Promise<ScopeChangeRequest> {
  const r = await api.patch<ApiResponse<ScopeChangeRequest>>(`/epc/scope-change-requests/${id}`, body);
  return r.data.data;
}
